export const SectionTitle = ({ title }: { title: string }) => {
  return (
    <div className={"mt-12 mb-8"}>
      <h2 className={"text-4xl font-extrabold"}>{title}</h2>
    </div>
  );
};
